import React from 'react';

export const columns = [
  {
    title: 'CAHRA Determination',
    dataIndex: 'cahra',
    key: 'cahra',
    colSpan: 1,
  },
  {
    title: 'Origin Countries',
    dataIndex: 'originCountries',
    key: 'originCountries',
    className: 'text-center',
    colSpan: 1,
    render: value => {
      const [nr, out] = value.split('/');
      return <span>
        <span style={{ color: 'red' }}>{nr}</span>/<span>{out}</span>
      </span>
    }
  },
  {
    title: 'Transit Countries',
    dataIndex: 'transitCountries',
    key: 'transitCountries',
    className: 'text-center',
    colSpan: 1,
    render: value => {
      const [nr, out] = value.split('/');
      return <span>
        <span style={{ color: 'red' }}>{nr}</span>/<span>{out}</span>
      </span>
    }
  },
  {
    title: 'Associated Countries',
    dataIndex: 'associatedCountries',
    key: 'associatedCountries',
    className: 'text-center',
    colSpan: 1,
    render: value => {
      const [nr, out] = value.split('/');
      if (value.split('/').length > 1) {
        return <span>
          <span style={{ color: Number(nr) > 0 ? 'red' : '' }}>{nr}</span>/<span>{out}</span>
        </span>
      }
      return value;
    }
  },
];

export const data = [
  {
    key: '1',
    cahra: 'Conflict Criteria',
    originCountries: '1/1',
    transitCountries: '1/3',
    associatedCountries: '0/1'
  },
  {
    key: '2',
    cahra: 'Governance & security criteria',
    originCountries: '1/1',
    transitCountries: '2/3',
    associatedCountries: '0/1'
  },
  {
    key: '3',
    cahra: 'Human Rights criteria',
    originCountries: '1/1',
    transitCountries: '2/3',
    associatedCountries: '0/1'
  },
  {
    key: '4',
    cahra: 'Money laundering and terrorism financing',
    originCountries: '1/1',
    transitCountries: '2/3',
    associatedCountries: '1/1'
  },
  {
    key: '5',
    cahra: 'Other risk factors',
    originCountries: '1/1',
    transitCountries: '3/3',
    associatedCountries: 'No determination'
  },
];

const all = {
  columns,
  data,
}

export default all;
